import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import { useScripts } from '../hooks/useScripts';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

function Features() {
  useDocumentTitle('Features');
  useScripts();
  
  useEffect(() => {
    // Trigger animations when component mounts
    const triggerAnimations = () => {
      // Dispatch scroll event to trigger css3-animate-it library
      window.dispatchEvent(new Event('scroll'));
      
      // Also manually trigger animations for visible elements
      setTimeout(() => {
        const animatedElements = document.querySelectorAll('.animated');
        animatedElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) {
            const originalClasses = el.className;
            el.className = originalClasses.replace(/\banimated\b/g, '').trim();
            void el.offsetHeight; // Force reflow
            setTimeout(() => {
              el.className = originalClasses;
            }, 10);
          }
        });
      }, 100);
    };
    
    // Trigger immediately and after a short delay
    triggerAnimations();
    setTimeout(triggerAnimations, 200);
    setTimeout(triggerAnimations, 500);
  }, []);
  const features = [
    {
      icon: 'feature-encryption.svg',
      title: 'AES-256 ENCRYPTION',
      description: 'Traffic through the VPN is encrypted with AES-256 where the client and server support it. On public Wi-Fi, at home, or on mobile, the local network sees a VPN connection rather than the sites you visit.',
      delay: 'delay-250'
    },
    {
      icon: 'feature-incognito.svg',
      title: 'IP MASKING',
      description: 'When you connect, sites you visit see the VPN IP instead of your home IP. That does not hide activity inside accounts you log into, and it does not mean advertisers never see you. Account and website records are described in our Privacy Policy.',
      delay: 'delay-500',
      center: true
    },
    {
      icon: 'feature-speed.svg',
      title: 'BUILT FOR SPEED',
      description: 'Privacy shouldn\'t mean slow. Speeds vary by server, network conditions, and your device. Browse, stream, and download over an encrypted connection subject to the limits in our Terms.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-unblock.svg',
      title: 'Reach more sites',
      description: 'Use the VPN on networks that allow it, including travel and public Wi-Fi, to reach content available through our servers. Follow the rules of your school, workplace, and local law. Circumventing network policy may violate those rules.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-ip.svg',
      title: 'Hide your IP address',
      description: 'When you connect, you receive a VPN IP that masks your home IP from sites that only look at IP address. That is not the same as being unidentifiable. Payment, email, and website records still exist as described in our Privacy Policy.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-malware.svg',
      title: 'Malware Protection',
      description: 'Our VPN will alert you if you visit sites that are known to contain malware, and then block the site. It detects and blocks more than 3.5 million malicious, phishing, and spam sites from infecting your device.',
      delay: 'delay-750'
    }
  ];

  return (
    <>
      <section className="bg-gray feature-grid-section animatedParent">
        <div className="container">
          <div id="Features" className="why-choose">
            <h2 className="title-head">Our Features</h2>
            <div className="row">
              {features.map((feature, index) => (
                <div key={index} className={`col-md-4 col-12 feature-item-col animated bounceInUp ${feature.delay}`}>
                  <div className={`inside ${feature.center ? 'center' : ''}`}>
                    <img
                      src={`/images/features/${feature.icon}`}
                      alt=""
                      className="feature-icon"
                      aria-hidden="true"
                    />
                    <a href="#">{feature.title}</a>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Features;
